import React from 'react';
import NumberBoxes from "../common/NumberBoxes/NumberBoxes";
import PerformanceBar from "../common/Charts/PerformanceBar";
import colors from "../common/Variables/Colors";
import {getGrowth, getMonthDutch, getYear} from "../common/Functions";
import Product from "../common/Product";

function DepartmentBody(props) {
    let revenueThisMonth = 0;

    let revenueThisMonthLastYear = 0;
    let revenueThisMonthLastYearTillNow = 0;
    let lastSoldItem = 0;
    if (typeof props !== "undefined") {
        if (typeof props.dataRevenue !== 'undefined') {
            revenueThisMonth = Math.round(props.dataRevenue.revenue_this_month);
            revenueThisMonthLastYear = Math.round(props.dataRevenue.revenue_this_month_last_year);
            revenueThisMonthLastYearTillNow = Math.round(props.dataRevenue.revenue_this_month_last_year_till_now);

            lastSoldItem = props.dataRevenue.lastSoldItem;
        }
    }

    return (
        <div>
            <NumberBoxes
                value1={Number(revenueThisMonthLastYearTillNow)}
                label1={"Momentopname " + getMonthDutch() + ' ' +  (getYear()-1)}
                growth1={getGrowth(revenueThisMonth, revenueThisMonthLastYearTillNow)}
                isMoney1={true}
                value2={revenueThisMonthLastYear}
                label2={"Maandomzet " + getMonthDutch() + ' ' + (getYear()-1)}
                growth2={getGrowth(revenueThisMonth, revenueThisMonthLastYear)}
                isMoney2={true}
            />
            <PerformanceBar label={"Momentopname " +  getMonthDutch() + ' ' +  (getYear()-1)} isPercentage={true} valueNow={revenueThisMonth} valuePrevious={revenueThisMonthLastYearTillNow}
                            colors={colors.blues}/>
            {typeof  lastSoldItem !== "undefined" && lastSoldItem !== {} ? <Product name={lastSoldItem.name} price={lastSoldItem.price}
                                                                                 img={lastSoldItem.image}/>  : null}

        </div>
    );
}

export default DepartmentBody;
